export default "__VITE_ASSET__OejxO58u__"